import { render, staticRenderFns } from "./ViewerPanelScreenshot.vue?vue&type=template&id=06f850a0&scoped=true"
import script from "./ViewerPanelScreenshot.vue?vue&type=script&lang=js"
export * from "./ViewerPanelScreenshot.vue?vue&type=script&lang=js"
import style0 from "./ViewerPanelScreenshot.vue?vue&type=style&index=0&id=06f850a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f850a0",
  null
  
)

export default component.exports